module.exports = __webpack_public_path__ + "static/media/Buildyourbrands_icon.53dc577c.svg";